import { Button, Tooltip, useApp } from '../ui';
import { FileDown } from 'lucide-react';
import { downloadCsv } from '../lib/downloadCsv';

/**
 * "Download template" button — fetches the sample CSV (the exact column headers + one filled-in
 * example row) for a bulk-import `kind`, so users can prepare their file before importing.
 *
 * Pair it next to the entity's Import button. The backend template endpoint (GET
 * /imports/templates/{kind}.csv) shares the same permission guard as the import, so render this
 * behind the SAME permission check as the Import button on that page.
 */
export function TemplateButton({
  kind,
  label = 'Template',
  size,
}: {
  kind: string;                         // e.g. 'retailers' — maps to /imports/templates/{kind}.csv
  label?: string;
  size?: 'small' | 'middle' | 'large';
}) {
  const { message } = useApp();
  return (
    <Tooltip title="Download the import template (column headers + a sample row) to prepare your file">
      <Button
        icon={<FileDown size={16} />}
        size={size}
        onClick={() =>
          downloadCsv(`/imports/templates/${kind}.csv`, `${kind}-template.csv`).catch(() =>
            message.error('Template unavailable'),
          )
        }
      >
        {label}
      </Button>
    </Tooltip>
  );
}
